'use client';

export { default } from './FormGroup';
export { default as formGroupClasses } from './formGroupClasses';
export * from './formGroupClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormGroup/index.js
// module id = 526
// module chunks = 25